export default __webpack_public_path__ + "static/media/rihanna_tweet.0887bc62.jpeg";